<template>
  <q-btn-dropdown
    split
    flat
    no-caps
    :class="isActive ? '' : 'text-grey-5'"
    class="site-category-chip"
    @click="$emit('toggle-platform')"
  >
    <template v-slot:label>
      <SiteIcon
        :social-site="platform"
        :color="isActive ? '' : 'grey-5'"
        size="sm"
        class="q-mr-xs"
      />
    </template>
    <q-list dense>
      <q-item
        clickable
        @click.stop="$emit('toggle-all')"
      >
        <q-item-section side>
          <q-checkbox
            :model-value="allSelected"
            dense
            @update:modelValue="$emit('toggle-all')"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label class="text-weight-bold">
            All Post Types
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        v-for="category in categories"
        :key="category.id"
        clickable
        @click.stop="$emit('toggle-category', category.id)"
      >
        <q-item-section side>
          <q-checkbox
            :model-value="allSelected || selectedCategoryIds.includes(category.id)"
            dense
            @update:modelValue="$emit('toggle-category', category.id)"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ category.name }}</q-item-label>
        </q-item-section>
      </q-item>
     <slot name="append"/>
    </q-list>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SocialSite, PostCategory } from '@/type';
import SiteIcon from '@/social/site/SiteIcon.vue';

export default defineComponent({
  emits: ['toggle-all', 'toggle-category', 'toggle-platform'],
  components: { SiteIcon },
  props: {
    platform: {
      type: Object as () => SocialSite,
      required: true,
    },
    categories: {
      type: Array as () => PostCategory[],
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    allSelected: {
      type: Boolean,
      required: true,
    },
    selectedCategoryIds: {
      type: Array as () => number[],
      required: true,
    },
  },
});
</script>
